import TaxiCorporationCargoTaxiContractListRequest from "../../../../api/raily/taxi-corporation/cargo-taxi-contract/list/taxi-corporation-cargo-taxi-contract-list.request";
import TaxiCorporationCargoTaxiContractListParams from "./taxi-corporation-cargo-taxi-contract-list-params";

const create = (
  params: TaxiCorporationCargoTaxiContractListParams,
): TaxiCorporationCargoTaxiContractListRequest => {
  return {
    taxiCorporationUuid: params.taxiCorporationUuid,
  };
};

const taxiCorporationCargoTaxiContractListParamsFactory = {
  create,
};

export default taxiCorporationCargoTaxiContractListParamsFactory;
